import React, { Fragment, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { StoreMedicineComposition } from "../../../../api/medicalStore/master/medicineCompositionAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

/* ======================
   Validation Schema
====================== */
const schema = yup.object().shape({
  name: yup.string().required("Composition name is required")
});

const AddMedicineComposition = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await StoreMedicineComposition(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(
          `${process.env
            .PUBLIC_URL}/medical-store/master/medicine-composition/list`
        );
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Medical Store" title="Add Medicine Composition" />

      <div className="container-fluid">
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h5>Add Medicine Composition</h5>

            <Link
              to={`${process.env
                .PUBLIC_URL}/medical-store/master/medicine-composition/list`}
            >
              <button className="btn btn-primary" id="list">
                List Composition
              </button>
              <UncontrolledTooltip target="list">
                List Composition
              </UncontrolledTooltip>
            </Link>
          </div>

          <form
            ref={formRef}
            className="form theme-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="card-body">
              <div className="row">
                {/* Composition Name */}
                <div className="col-6">
                  <div className="form-group">
                    <label>Composition Name</label>
                    <input
                      className="form-control"
                      placeholder="Enter composition name"
                      {...register("name")}
                    />
                    {errors.name &&
                      <p className="text-danger">
                        {errors.name.message}
                      </p>}
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer text-end">
              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default AddMedicineComposition;
